import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MdInputModule, MdDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AppGlobals } from '../../../Common/Services/app.global';
import { Utility } from '../../../Common/Services/utility';
import { AppMessage } from '../../../Common/appMessage';
import { SharedService } from "../../../Common/Services/shared.service";
import { AdmManageErrorCaseService } from './adm-manage-error-case.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-adm-manage-error-case',
  templateUrl: './adm-manage-error-case.component.html',
  styleUrls: ['./adm-manage-error-case.component.css'],
  providers: [AdmManageErrorCaseService]
})
export class AdmManageErrorCaseComponent implements OnInit {
  title: string = "Error Case Details";
  form: FormGroup;
  formControl: any;
  changeStatusto = [["COMPLETED", "Marking as Completed"], ["EXAMSTOSCHEDULE", "Allowing user to reschedule"]];
  isChangeStatus: boolean = false;
  eligibilityCode: any;
  isdisableUpdate: boolean = false;
  constructor(public _utility: Utility, private _admManageErrorCaseService: AdmManageErrorCaseService, private _sharedService: SharedService, private _activatedRoute: ActivatedRoute, private _appMessage: AppMessage, public _appGlobals: AppGlobals) {
    this.form = new FormGroup({
      candidateName: new FormControl(''),
      locationName: new FormControl(''),
      examCodeName: new FormControl(''),
      statusDisplay: new FormControl(''),
      changeStatusTo: new FormControl('', [Validators.required]),
      scheduleId: new FormControl(''),
    });
    this.form.valueChanges
      .subscribe(form => {
        this._utility.setTxnStatus(true); // display confirm box for FORM changes
      });
  }

  ngOnInit() {
    this._appGlobals.routeWithID = false;
    this.eligibilityCode = this._activatedRoute.snapshot.params["id"];
    this.getErrorDetailById();
  }

  getErrorDetailById() {
    let queryParams = "?eligibilityCode=" + this.eligibilityCode;
    this._sharedService.getEligibilities(queryParams).subscribe(
      response => {
        this._utility.onSuccessCallback(response, null, function () {
          if (response && response.response) {
            let data = response.response.results[0];
            let finalData = this._utility.manageFormComboData(data);
            if (finalData) {
              this.form.patchValue(finalData);
            }
            this._utility.disableEnableForm(this.form, true);
            this.form.controls.changeStatusTo.enable()
          }
        }.bind(this));
      },
      error => this._utility.onErrorCallback(error)
    )
  };

  private onRequest(callback: () => Observable<any>) {
    if (this.form.controls.changeStatusTo && this.eligibilityCode) {
      callback().subscribe(
        data => {
          let successMsg = this._appMessage.getItem["UMsg00031"];//"get msg of status successfully";
          this._utility.onSuccessCallback(data, successMsg, function () {
            this.form.disable();
            this.isdisableUpdate = true;
            this._utility.clearTxnStatus(); // close confirm box for FORM changes
          }.bind(this));
        }, error => {
          this._utility.onErrorCallback(error);
        }
      );
    }
  }

  markAsComplete() {
    this.onRequest(() => this._admManageErrorCaseService.markAsComplete({
      scheduleId: this.form.controls.scheduleId.value,
    }))
  }

  allowUserToReschedule() {
    this.onRequest(() => this._admManageErrorCaseService.allowUserToReschedule({
      scheduleId: this.form.controls.scheduleId.value,
    }))
  }
  
  onUpdate() {
    if (this.form.controls.changeStatusTo.value === "COMPLETED") {
      this.markAsComplete();
    } else if (this.form.controls.changeStatusTo.value === "EXAMSTOSCHEDULE") {
      this.allowUserToReschedule();
    }
  }
}




// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-eligibilities/adm-manage-error-case/adm-manage-error-case.component.ts